let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hTS6V")).then(() => parcelRequire('dFIAI'));